import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/dist/client/router';
import { useDispatch, useSelector } from 'react-redux';
import { authSelector } from '../../store/feature/authSlice';
import {
  clearListings,
  getAllListings,
  listingSelector,
} from '../../store/feature/listingSlice';
import Listings from '../../components/Listings/Listings';
import ReactPaginate from 'react-paginate';
import CustomLoading from '../../components/Shared/Loading/CustomLoading';
import NewListings from '../../components/Listings/NewListings';
import Listing_Filter from '../../components/Shared/Listing_Filter';
import Breadcrumb from '../../components/Shared/Breadcrumb';
import { Listing_text } from '../../constant/Translation/Listing';
import {
  collectionsSelector,
  getCollectionData,
} from '../../store/feature/Collections/CollectionsSlice';
import ListingsList from '../../components/Listings/ListingsList';
import { check_login } from '../../constant/check_auth';
import { General_text } from '../../constant/Translation/General';
import { Menubar_text } from '../../constant/Translation/Heading';
import InfiniteScroll from 'react-infinite-scroll-component';
import ListingDynamicSkeleton from '../../components/Shared/skeletonUI/Listing/ListingDynamicSkeleton';
import { TYPE_CONSTANT } from '../../constant/Web_constant';

const CollectionListingsPageLayout2 = () => {
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const router = useRouter();
  const dispatch = useDispatch();
  const { auth_key, first_name } = useSelector(authSelector);

  const { collection_data } = useSelector(collectionsSelector);

  const loadMoreData = () => {
    if (hasMore) {
      const nextPage = page + 1;
      dispatch(
        getCollectionData({
          bodyParam: {
            id: collection_data?.id,
            data_page: nextPage,
          },
        })
      ).then((res) => {
        if (res.payload?.collections?.length === 0) {
          setHasMore(false);
        } else {
          setPage(nextPage);
        }
      });
    }
  };

  // useEffect(() => {
  //   dispatch(
  //     getCollectionData({
  //       bodyParam: {
  //         id: collection_data?.id,
  //         data_page: 1,
  //       },
  //     })
  //   );
  // }, [collection_data?.id]);

  return (
    <>
      <div>
        <div className="flex flex-col gap-2 mt-4 mb-8">
          {collection_data?.title && (
            <h1 className="title-h1 text-start ">{collection_data?.title}</h1>
          )}
          {collection_data?.description && (
            <p className="description-paragraph text-start">
              {collection_data?.description}
            </p>
          )}
        </div>
        {collection_data?.listings === null ||
        collection_data?.listings?.length > 0 ? (
          <InfiniteScroll
            dataLength={collection_data?.listings?.length || 0}
            next={loadMoreData}
            hasMore={hasMore}
            loader={
              <ListingDynamicSkeleton
                listings_type={'list'}
                listing_card_type={
                  TYPE_CONSTANT.STYLES_CONFIGS?.listing_card?.card_type?.type
                }
                per_page={15}
              />
            }
          >
            <ListingsList
              Products={collection_data?.listings}
              is_hide_like_btn={true}
            />
          </InfiniteScroll>
        ) : (
          <div className=" w-full h-[200px] mt-5 flex justify-center items-start">
            <div
              className="w-full    md:w-5/6 bg-yellow-500    text-white px-4 py-3 rounded-card  relative grid grid-cols-[5%,80%]"
              role="alert"
            >
              <div className="flex items-center justify-center w-6 ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                  />
                </svg>
              </div>
              <div className="ml-5">
                <span className="   md:ml-2">
                  {Listing_text.productlist.no_products_found}
                </span>
              </div>
            </div>
          </div>
        )}{' '}
        <div className="my-2">
          <Breadcrumb
            lists={[
              { name: General_text.general.home, link: '/' },
              { name: Menubar_text.more.all_listings, link: '/l' },
              {
                name: collection_data?.title,
                link: ``,
              },
            ]}
          />
        </div>
      </div>
    </>
  );
};

export default CollectionListingsPageLayout2;
